
import { h, defineComponent, ref, onMounted } from 'vue';

export default defineComponent({
    props: {
        icon: {
            type: String,
            required: true,
        },
    },
    setup(props) {
        const svg = ref<HTMLElement | null>();

        onMounted(() => {
            if (!svg.value) return;
            const data = require(`@/assets/inline-icons/${props.icon}.svg`);
            svg.value.outerHTML = data.default;
        });

        return () => h('svg', { ref: svg });
    },
});
